import { applyPromoOverride } from 'yoda-core-components/lib/helpers/Stylitics';
import get from 'lodash/get';
import { miniPDPOnShopTheLookOpen } from 'yoda-site-components/lib/actions/MiniPDPAction';
import {
    shopTheLookLoadSuccess,
    shopTheLookMiniPDPClickEvent,
} from '../../../actions/AnalyticsAction';

let _onOutfitsLoaded = null;
let _onItemClick = null;
let _lastClickPosition = 0;

const mixAndMatchConfig = {
    id: 'mix-and-match',
    containerId: 'stylitics-composer-container',
    title: 'How to Style It',
    titleId: 'widget-title',
    featureFlagKey: 'enableMixAndMatch',
    imageQuery: '.stylitics-ui-image',

    getScriptURL: (prefs) => get(prefs, 'styliticsWidget.scriptURL', ''),

    createWidget: async (itemNumber) => {
        if (typeof StyliticsComposer === 'undefined') {
            throw new Error('StyliticsComposer is not available');
        }
        return StyliticsComposer.initialize({
            client: 'jcpenney_home',
            target: 'stylitics-composer-container',
            config: {
                modules: [
                    {
                        type: 'grid',
                        params: {
                            api: {
                                item_number: itemNumber,
                                min: 3,
                                max: 6,
                            },
                            display: {
                                showMobileArrows: true,
                                nonEditorialImages: true,
                                itemInfoStatic: true,
                                typeScaledGrid: true,
                                maxGridSize: 5,
                            },
                            text: {
                                counterHeading: 'Room',
                            },
                        },
                        on: {
                            'mount.item': ({ item, element }) => {
                                applyPromoOverride(element, item);
                            },
                            'load.data': ({ outfits }) => {
                                _onOutfitsLoaded?.(outfits);
                            },
                        },
                        override: {
                            'click.item': (data) => {
                                const item = data?.item;
                                const outfit = data?.outfit;
                                const position = (outfit?.items || []).findIndex(
                                    (i) => i.item_id === item?.item_id
                                );
                                _lastClickPosition = position >= 0 ? position : 0;
                                _onItemClick?.(item, outfit);
                            },
                        },
                    },
                ],
            },
        });
    },

    registerEvents: (instance, { onOutfitsLoaded, onItemClick }) => {
        _onOutfitsLoaded = onOutfitsLoaded;
        _onItemClick = onItemClick;
    },

    refresh: (instance, itemNumber) => {
        instance?.refresh?.({ sharedParams: { api: { item_number: itemNumber } } });
    },

    analyticsLoadAction: shopTheLookLoadSuccess,
    analyticsClickAction: ({ id, ppId }) =>
        shopTheLookMiniPDPClickEvent({
            moduleName: 'how to style it',
            shopTheLookID: id,
            shopTheLookPPID: ppId,
            linkText: 'Shop',
            linkPosition: _lastClickPosition,
        }),
    miniPDPAction: miniPDPOnShopTheLookOpen,
    analyticsModule: 'how to style it',
};

export default mixAndMatchConfig;
